import { render, staticRenderFns } from "./WaitingForSchedule.vue?vue&type=template&id=2c4eea0a&"
import script from "./WaitingForSchedule.vue?vue&type=script&lang=ts&"
export * from "./WaitingForSchedule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports